// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.result-photo[data-v-5c4b5dfe] {\n    width: 100%;\n    height: auto;\n    display: block;\n}\n#result-photo-modal[data-v-5c4b5dfe] {\n    user-select: none;\n}\n", ""]);
// Exports
module.exports = exports;
